import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { installDiagnostics } from "@/shared/diagnostics";
import { App } from "./app/App";
import "./styles/index.css";

/*
 * Before anything renders, and before the root element is even looked for.
 *
 * The errors worth capturing most are the ones thrown while the app is still
 * booting - a bad bundle, a failed import, a missing #root - because those are
 * the ones the user experiences as a white screen and can describe in no other
 * way. Installing this from a component would mean the buffer starts recording
 * only once the app is already working.
 */
installDiagnostics();

const container = document.getElementById("root");
if (!container) throw new Error("index.html is missing #root");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
